import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createShipmentBookmark } from '@/features/auth'

export const useShipmentBookmarkCreate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createShipmentBookmark,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['getShipmentBookmarks'],
      })
    },
  })
}
